import { useState, useEffect } from "react";
import localforage from "localforage";

import Typography from "@mui/joy/Typography";
// import Divider from "@mui/joy/Divider";
import Stack from "@mui/joy/Stack";
import Tooltip from "@mui/joy/Tooltip";

import { getIcon } from 'utils/misc';


type ChipOpenCloseType = {
    title: string;
    defaultOpen: boolean;
    cached?: string;
    children: React.ReactNode;
};

const ChipOpenClose = ({title, defaultOpen, cached="", children}: ChipOpenCloseType ) => {
    const DownIcon = getIcon('ArrowDropDown');
    const [open, setOpen] = useState(defaultOpen);
    const [loaded, setLoaded] = useState(false);
    const cacheKey = cached || title;

    useEffect(() => {
        localforage.getItem<string>(cacheKey)
            .then((value) => {
                setLoaded(true);
                if (value) {
                    setOpen(value === 'yes');
                }
            })
            .catch(() => {
                // if we have an error loading status, just leave it open
                setOpen(true);
            });
    }, [cacheKey, setOpen]);

    function doSetOpen(open: boolean) {
        localforage.setItem(cacheKey, open ? 'yes' : 'no').then(() => {
            setOpen(open);
        });
    }

    const trans = "all .25s ease-in-out"
    return (
        <>
            <Tooltip
                placement="bottom-start"
                title={(open ? "Hide" : "Show") + ` this section`}>
                <Typography
                    level="title-lg"
                    variant="plain"
                    color="neutral"
                    sx={{ cursor: "pointer" }}
                    endDecorator={!open ?
                        <DownIcon color="primary" sx={{ transform: 'rotate(-90deg)', transition: trans, opacity: "0.9" }} /> :
                        <DownIcon color="primary" sx={{ transition: trans, opacity: "0.4" }} />}
                    onClick={() => doSetOpen(!open)}
                >{title}
                </Typography>
            </Tooltip>
            {open &&
                (loaded ?
                    <Stack >{children}</Stack> :
                    <Stack direction="row" justifyContent="center"><Typography level="body-sm">Here we go!</Typography></Stack>)}
        </>
    );
};

export default ChipOpenClose;
